import script from "./AdminCommentManageView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCommentManageView.vue?vue&type=script&setup=true&lang=js"

import "./AdminCommentManageView.vue?vue&type=style&index=0&id=0969b74e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0969b74e"]])

export default __exports__